<script setup>
import { computed } from 'vue'
import { ALL_GENRES } from '@utils/library-collections'

const props = defineProps({
    genres: { type: Array, default: () => [] },
    selected: { type: String, default: ALL_GENRES },
})
const emit = defineEmits(['change'])

const pills = computed(() => [ALL_GENRES, ...props.genres])
const isVisible = computed(() => props.genres.length >= 2)
</script>

<template>
    <div
        v-if="isVisible"
        class="pills"
    >
        <button
            v-for="pill in pills"
            :key="pill"
            type="button"
            class="pill"
            :class="{ active: pill === selected }"
            @click="emit('change', pill)"
        >{{ pill }}</button>
    </div>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.pills {
    display: flex;
    gap: $s-xs;
    align-items: center;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
}

.pill {
    padding: $s-xs $s-m;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
    color: $c-text-faded;
    white-space: nowrap;
    cursor: pointer;
    background: $c-charade-grey;
    border: 1px solid $c-shark-grey;
    border-radius: 999px;

    &.active {
        color: $c-black;
        background: $c-highlight;
        border-color: $c-monarch-red;
    }

    &:focus-visible {
        outline: 2px solid $c-highlight;
        outline-offset: 2px;
    }
}
</style>
